import { formatCurrency, formatPercentage } from '@roc/ui/utils';
import { ItemDisplay, LeverageCard, LeverageCardRow } from './leverageComponents';
import { SuggestedLeverageCardProps } from '../leverageStep';

export const FixFlipSuggestedLeverageCard = ({
  suggestedLoanQuote,
  quoteTypeStore,
}: SuggestedLeverageCardProps) => {
  const {
    initialAdvance = 0,
    constructionHoldback = 0,
    totalPurchasePrice = 0,
    totalProposedConstructionBudget = 0,
    loanToCost = 0,
    totalLoanAmount = 0,
    totalAfterRepairValue = 0,
    afterRepairLtv = 0,
    ltfc = 0,
  } = suggestedLoanQuote;

  const constructionReserve =
    totalProposedConstructionBudget > 0
      ? (constructionHoldback / totalProposedConstructionBudget) * 100
      : 0;

  const purchasePriceLabel = quoteTypeStore.isMidConstructionRefinance()
    ? 'Cost Spent to Date'
    : 'Purchase Price';

  return (
    <LeverageCard
      title="Suggested Insta-Quote"
      subtitle="Calculated during loan submission. For reference only."
      disabled={false}
      instaQuote={true}
      LeverageMatrixCard={null}
      quoteTypeStore={null}
      disabledWarning={false}
    >
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Initial Loan Amount"
            value={formatCurrency(initialAdvance)}
          />
        }
        divisor={
          <ItemDisplay
            label={purchasePriceLabel}
            value={formatCurrency(totalPurchasePrice)}
          />
        }
        result={
          <ItemDisplay
            label="Loan to Cost"
            value={formatPercentage(loanToCost)}
          />
        }
      />
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Construction Holdback"
            value={formatCurrency(constructionHoldback)}
          />
        }
        divisor={
          <ItemDisplay
            label="Proposed Construction Budget"
            value={formatCurrency(totalProposedConstructionBudget)}
          />
        }
        result={
          <ItemDisplay
            label="Construction Reserve"
            value={formatPercentage(constructionReserve)}
          />
        }
      />
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Total Loan Amount"
            value={formatCurrency(totalLoanAmount)}
          />
        }
        divisor={
          <ItemDisplay
            label="After Repair Value"
            value={formatCurrency(totalAfterRepairValue)}
          />
        }
        result={
          <ItemDisplay
            label="ARLTV"
            value={formatPercentage(afterRepairLtv)}
          />
        }
      />
      <LeverageCardRow
        dividend={
          <ItemDisplay
            label="Total Loan Amount"
            value={formatCurrency(totalLoanAmount)}
          />
        }
        divisor={
          <ItemDisplay
            label="Cost Basis"
            value={formatCurrency(totalPurchasePrice + totalProposedConstructionBudget)}
          />
        }
        result={
          <ItemDisplay
            label="LTFC"
            value={formatPercentage(ltfc)}
          />
        }
      />
    </LeverageCard>
  );
};
